import React from 'react';
import { useParams } from 'react-router-dom';
import HeaderComponent from '../components/General/HeaderComponent';
import MenuBarComponent from '../components/Panel/MenuBarComponent';
import GanttComponent from '../components/Panel/GanttComponent';

const Gantt = () => {
  const { id } = useParams(); // projectId (aslında proje slug'ı)
  
  if (!id) {
    return (
      <div className="w-full dark:bg-dark-100 bg-stone-100 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Proje Bulunamadı</h2>
          <p className="text-gray-600 dark:text-gray-400">Geçerli bir proje seçiniz.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full dark:bg-dark-100 bg-stone-100 min-h-screen">
      <div className="container mx-auto">
        <HeaderComponent title="Gantt Şeması" />
        <MenuBarComponent title="gantt" />
        <div className="mt-2 bg-white dark:bg-dark-200 rounded-xl shadow-sm border border-gray-200 dark:border-dark-300 mb-6 h-[calc(100vh-200px)] overflow-hidden">
          <GanttComponent projectId={id} />
        </div>
      </div>
    </div>
  );
};

export default Gantt;
